import { adminWorkspaceDeveloperQueryKeys as e } from "./useAdminWorkspaceDeveloperQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { adminWorkspaceDeveloperApi as n } from "@maat/api-main";
//#region src/workspaceDeveloper/useAdminWorkspaceDeveloperKeysQuery.ts
var r = (r, i = !0) => t({
	queryKey: e.keys(r),
	queryFn: () => n.keys(r),
	enabled: i && !!r
});
//#endregion
export { r as useAdminWorkspaceDeveloperKeysQuery };
